import { NewLoginModal, PoiInfoG, Toast } from '@mtfe/sweet-components';
import { loadLogin, autoLogin, reportMonitorLog } from '@mtfe/sweet-oad';
import { createDeepLink, dom, eventBus, common } from '@mtfe/sweet-utils';
import { COUPON_STATUS } from '../static/index';
import store from '../store/index';
import http from '../service/index';

const { $id } = dom;
const { storeCommon, storeCoupon, storeRedBag } = store;
const { storeOptionalWelfare, storeDailyDeals } = storeCoupon;
const { errorReportApi, successReportApi } = reportMonitorLog;
const deepLink = createDeepLink();
const { isArray, debounce } = common;

// loading相关
export const showLoading = (isShowLoading) => {
    storeCommon.isLoading = true;
    if (isShowLoading) {
        $id('loading').style.display = 'flex';
    }
};
export const hideLoading = () => {
    storeCommon.isLoading = false;
    $id('loading').style.display = 'none';
};

// 过滤相关
export const filterRedBag = (infoList = []) =>
    infoList.filter((item) => item.giftInfo && item.giftInfo.type === 2);

export const filterPoiList = (infoList = []) => infoList.filter((item) => item.poi_id_str);

export const filterCouponList = (infoList = []) => infoList.filter((item) => item.giftInfo);

export const filterNewCoupon = (infoList = []) => {
    if (!isArray(infoList)) {
        throw new Error('infoList is not an array');
    }
    return infoList.filter(
        (item) => item.giftInfo && item.giftInfo.status === COUPON_STATUS.STATUS_NEW,
    );
};

export const filterNewCouponIDs = (infoList = []) =>
    filterNewCoupon(infoList).map((item) => item.giftInfo.gift_id);

export const changeCouponStatus = (recallBizId, giftID, success) => {
    const { effectData } = storeDailyDeals;
    effectData[recallBizId].couponList.forEach((poiInfo) => {
        if (poiInfo.giftInfo && poiInfo.giftInfo.gift_id === giftID && success) {
            poiInfo.giftInfo.status = COUPON_STATUS.STATUS_RECEIVED;
        }
    });
};

// recallBizId绑定在按钮上
// 列表底部的提示getBottomTipID通过getBottomTipID获得
export const getBottomTipID = (recallBizId) => `bottom_tip_${recallBizId}`;

// 列表容器getPoiContainerID通过getPoiContainerID获得
export const getPoiContainerID = (recallBizId) => `poi_container_${recallBizId}`;

/**
 * eventBus事件总线中，触发当前列表展示标识
 * @param {string} recallBizId
 * @returns {string}
 */
export const getOnClickEventName = (recallBizId) => `onclick_${recallBizId}`;

export const fetchAllData = async (option = {}) => {
    const { listInfo } = option;
    const { recallBizId, pageNo } = listInfo;
    try {
        const res = await http.actGetPoiList(recallBizId, pageNo);
        const { phone } = res;
        storeCommon.phone = phone;
        listInfo.pageNo += 1;

        successReportApi.reportSearchSuccess('商家数据检索成功');
        return res;
    } catch (error) {
        console.error(error);
        const logInfo = JSON.stringify(error.message || error.msg);
        errorReportApi.reportRequestError(logInfo);
        return null;
    }
};

export const fetchDataList = async (option = {}) => {
    const { isShowLoading = true } = option;
    try {
        if (storeCommon.isLoading) {
            return;
        }
        showLoading(isShowLoading);
        const res = await fetchAllData(option);
        const { infos: resInfos } = res;

        return resInfos.filter((item) => item.poi_id_str);
    } catch (error) {
        console.error(error);
        return [];
    } finally {
        hideLoading();
    }
};

export const checkLoginStatus = async (cb) => {
    const { phone, loginSuccessCb } = storeCommon;
    if (phone) {
        const res = await cb();
        return res;
    }
    NewLoginModal({ loadLogin, loginSuccessCb });
    return false;
};

/**
 * 多张券领取
 * @param {Array} giftIDs
 * @param {string} recallBizId
 * @returns {Promise}
 */
export const receiveAllCoupon = async (giftIDs, recallBizId) => {
    try {
        if (giftIDs.length === 0) {
            Toast({ message: '领取成功', position: 'center' });
            // 已经全部领取
            return;
        }
        const recvRes = await http.actGeRecvVer4Multi(giftIDs, recallBizId);
        if (recvRes && recvRes.rets && recvRes.rets.length) {
            // 处理全部或者部分券领取成功的情况
            // 存储券的领取成功与否状态
            const recvResList = [];
            recvRes.rets.forEach((item, index) => {
                const curGift = {
                    giftId: giftIDs[index],
                    status: item,
                };
                recvResList.push(curGift);
            });
            // 更新券状态
            recvResList.forEach((curGift) => {
                changeCouponStatus(recallBizId, curGift.giftId, curGift.status === 0); // curGift.status === 0 领券成功
            });

            if (recvResList.length === recvResList.filter((item) => item.status === 0).length) {
                // 领券数 === 成功数
                // 修改一键领取按钮状态
                Toast({ message: '领取成功', position: 'center' });
                successReportApi.reportCouponSuccess('多张券领取成功');
            }
        }
    } catch (error) {
        const logInfo = JSON.stringify(error.message || error.msg);
        errorReportApi.reportCouponError(logInfo);
        console.error(error);
    }
};

// 单个券领取
export const receiveOneCoupon = async (giftID, recallBizId) => {
    try {
        const giftIds = [giftID];
        const res = await http.actGeRecvVer4Multi(giftIds, recallBizId);
        successReportApi.reportCouponSuccess('单张券领取成功');
        return res;
    } catch (error) {
        const logInfo = JSON.stringify(error.message || error.msg);
        errorReportApi.reportCouponError(logInfo);
        console.error(error);
    }
};

/**
 * 渲染商家的模板
 * @param {*} poiInfo
 * @param {*} itemIndex
 * @returns
 */
export const renderPoi = (poiInfo, itemIndex) => {
    const info = PoiInfoG({
        poiInfo,
        itemIndex,
        showCoupon: false,
        isLazyLoadImg: false,
        onPoiInfoClick: () => {
            const cb = () => {
                const componentID = PoiInfoG.describe.getComponentID();
                const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
                deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {
                    http.actGeClkM(url);
                });
            };
            const autoLoginOptions = {
                cb,
                phone: storeCommon.phone,
                loginSuccessCb: storeCommon.loginSuccessCb,
            };
            const urlParams = {
                redirectDeviceId: storeCommon.deviceId,
            };
            autoLogin(autoLoginOptions, urlParams);
        },
    });
    return `<div class="mb16">${info}</div>`;
};

export const renderPoiWithCoupon = (poiInfo, itemIndex, recallBizId) => {
    const { effectData } = storeOptionalWelfare;

    const getCouponAndGotoDeep = async () => {
        // 获取所有的商家，同一个商家可能出现在不同品类下面
        const btnDom = document.querySelectorAll(`[data-poiid-btn='${poiInfo.poi_id_str}']`);
        const btnDomArr = Array.from(btnDom);
        const { giftInfo } = poiInfo;

        if (giftInfo.status === COUPON_STATUS.STATUS_RECEIVED) {
            // 如果券已经被领取，直接跳转
            // 上报点击
            const componentID = PoiInfoG.describe.getComponentID();
            const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
            deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {
                http.actGeClkM(url);
            });
        } else if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
            // 如果券没有被领取，且有领券的机会，那么就尝试领券
            // leftRecvNum > 0 代表存在领券机会
            // leftRecvNum = 0 代表领券机会已经用完
            if (effectData.leftRecvNum > 0) {
                try {
                    const res = await receiveOneCoupon(giftInfo.gift_id, recallBizId);
                    const { rets, leftRecvNum } = res;
                    effectData.leftRecvNum = leftRecvNum;
                    if (rets[0] === 0) {
                        Toast({ message: '领取成功', position: 'center' });
                        eventBus.$emit('OptionalWelfare-changeTimes', effectData.leftRecvNum);
                    }

                    // 变更券状态
                    Object.keys(storeOptionalWelfare.poiData).forEach((key) => {
                        const currentObj = storeOptionalWelfare.poiData[key];
                        currentObj.poiList.forEach((item) => {
                            if (item.poi_id_str === poiInfo.poi_id_str) {
                                item.giftInfo.status = COUPON_STATUS.STATUS_RECEIVED;
                            }
                        });
                    });
                    // 变更按钮状态
                    if (btnDomArr.length) {
                        btnDomArr.forEach((item) => {
                            item.innerHTML = '立即使用';
                        });
                    }
                    // 上报点击
                    const componentID = PoiInfoG.describe
                        .getSubComponent('Coupon')
                        .getComponentID();
                    const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
                    http.actGeClkM(url);
                } catch (error) {
                    console.error(error);
                }
            } else if (effectData.leftRecvNum === 0) {
                Toast({ message: '今日领券机会已用完' });
            }
        }
    };
    const onCouponBtnClickHandler = debounce(async () => {
        const autoLoginOptions = {
            cb: getCouponAndGotoDeep,
            phone: storeCommon.phone,
            loginSuccessCb: storeCommon.loginSuccessCb,
        };
        const urlParams = {
            redirectDeviceId: storeCommon.deviceId,
        };

        autoLogin(autoLoginOptions, urlParams);
    }, 500);
    const info = PoiInfoG({
        poiInfo,
        itemIndex,
        showCoupon: true,
        isLazyLoadImg: false,
        onPoiInfoClick: () => {
            // 在点击商家的时候，尝试领券再跳转
            const cb = () => {
                // 不进行领券
                // getCouponAndGotoDeep();
                const componentID = PoiInfoG.describe.getComponentID();
                const url = `${poiInfo.clickMonitorUrl}&componentId=${componentID}`;
                deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {
                    http.actGeClkM(url);
                });
            };
            const autoLoginOptions = {
                cb,
                phone: storeCommon.phone,
                loginSuccessCb: storeCommon.loginSuccessCb,
            };
            const urlParams = {
                redirectDeviceId: storeCommon.deviceId,
            };
            autoLogin(autoLoginOptions, urlParams);
        },
        onCouponBtnClick: onCouponBtnClickHandler,
    });
    return `<div class="mb16">${info}</div>`;
};

/**
 * 创建商家列表的DOM
 * @returns
 */
export const createPoiListDom = (poiList = [], recallBizId) => {
    const renderFunc = storeOptionalWelfare.isWelfare(recallBizId)
        ? renderPoiWithCoupon
        : renderPoi;
    const returnList = poiList.map((poiInfo, index) => renderFunc(poiInfo, index, recallBizId));
    return returnList.join('');
};

/**
 * 关闭骨架屏
 */
export const hideSkeleton = () => {
    const skeleton = $id('skeleton-screen');
    skeleton.style.opacity = 0;
    setTimeout(() => {
        skeleton.style.display = 'none';
    }, 500);
};

export const clickDebounce = (fn) => {
    let canRun = true;
    return async function (...args) {
        if (canRun) {
            canRun = false;
            try {
                return await fn(...args);
            } finally {
                canRun = true;
            }
        }
    };
};
